import { useRouteLoaderData } from "react-router"
import { TokenIcon } from "@tutellus/tutellus-components"
import { RootDataLoader } from "../../../pages/DataRoot/loader"
import { truncateAddress } from "../../../js/string"
import styles from "./index.module.css"
import { getExplorerTokenURL } from "../../../js/chain"

export type TokenAddressCellProps = {
  tokenID: string
}

export const TokenAddressCell = ({ tokenID }: TokenAddressCellProps) => {
  const { projectConfig } = useRouteLoaderData("root") as RootDataLoader

  const tokenConfig =
    projectConfig.tokens.find((token) => token.id === tokenID) ||
    projectConfig.pools.find((pool) => pool.id === tokenID)

  const tokenName = tokenConfig?.name || tokenID
  const tokenSymbol = tokenConfig?.symbol || tokenID
  const tokenAddress = projectConfig.addresses.find((token) => token.tokenID === tokenID)?.address
  const truncatedAddress = tokenAddress ? truncateAddress(tokenAddress) : ""
  const explorerTokenURL = tokenAddress ? getExplorerTokenURL(tokenAddress) : ""

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <TokenIcon iconKey={tokenID} size="2xl" />
        <div className={styles.info}>
          <p className={styles.name}>{tokenName}</p>
          <p className={styles.address}>
            <span>{tokenSymbol}</span>
            {tokenAddress && (
              <a className={styles.link} href={explorerTokenURL} target="_blank" rel="noreferrer">
                {truncatedAddress}
              </a>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}
